import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { orderBy } from 'lodash';
import { Briefs } from '../../models/index';
import { DialogService, JobsService } from '../../services/standard/index';

@Component({
  selector: 'prism-brief-modal',
  templateUrl: './brief-modal.component.html',
  styleUrls: ['./brief-modal.component.scss']
})
export class BriefModalComponent implements OnInit {
  briefs: Briefs;
  briefKeys;
  onHomePage: boolean;

  constructor(public dialogService: DialogService, private router: Router, public jobsService: JobsService) {
  }

  ngOnInit() {
    this.onHomePage = this.router.isActive('home/jobs', true);

    const briefs = this.dialogService.inputData.briefs;
    if (!!briefs) {
      this.briefKeys = orderBy(Object.keys(briefs), ['briefTimestamp'], 'desc');
      this.briefs = briefs;
    }
  }
}
